import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { Helmet } from 'react-helmet';
import { useEmbed } from '@tribeplatform/react-sdk/hooks';
export const EmbedRenderer = ({ domNode, embeds, className, context, }) => {
    // Fetch the corresponding embed id
    const embedId = domNode.attribs['data-id'];
    const url = domNode.attribs['data-embed-url'];
    const initialData = embeds === null || embeds === void 0 ? void 0 : embeds.find(embed => embed.id === embedId);
    const { data: embed } = useEmbed({
        variables: {
            url,
            options: JSON.stringify({
                iframe: '1',
                omit_script: '1',
            }),
        },
        useQueryOptions: {
            initialData,
            cacheTime: Infinity,
            staleTime: Infinity,
            enabled: !!(initialData === null || initialData === void 0 ? void 0 : initialData.html),
        },
    });
    if (!url)
        return null;
    const embedRendered = (_jsxs(_Fragment, { children: [_jsx("div", { className: "preview relative w-full", children: (embed === null || embed === void 0 ? void 0 : embed.html) ? (_jsx("figure", { dangerouslySetInnerHTML: { __html: embed === null || embed === void 0 ? void 0 : embed.html } }, void 0)) : (_jsx("a", { href: url, target: "_blank", children: url }, void 0)) }, void 0), _jsx(Helmet, { children: _jsx("script", { src: "//cdn.iframe.ly/embed.js", async: true }, void 0) }, void 0)] }, void 0));
    if ((embed === null || embed === void 0 ? void 0 : embed.type) === 'video')
        return (_jsx("div", { className: clsx(context === 'compact' && 'aspect-video max-h-64', className), children: embedRendered }, void 0));
    return embedRendered;
};
//# sourceMappingURL=EmbedRenderer.js.map